// extracted by mini-css-extract-plugin
export default {"cls1":"RelatedPapers-cls1__rB","cls2":"RelatedPapers-cls2_I_Q RelatedPapers-cls1__rB"};